export class Wrsv {
    id: string;
    scssvId: string;
    oem: string;
    model: string;
    equipmentBrand: string;
    sizeIn: number;
    ratingPsi: number;
    manufacturer: string;
    partNo: string;
    initialInstalledDate: string;
    latestInstalledDate: string;
    subsequentInstalledDate: string;
    installationDepth: number;
    installationAtSvlntrsv: string;
    trsvType: string;
    status: string;
    remark: string;

    constructor(initialValues: Partial<Wrsv> = {}) {
        Object.assign(this, initialValues);
    }

    reset() {
        const initialValues: Partial<Wrsv> = {
            id: '',
            scssvId: '',
            oem: '',
            model: '',
            equipmentBrand: '',
            sizeIn: 0,
            ratingPsi: 0,
            manufacturer: '',
            partNo: '',
            initialInstalledDate: '',
            latestInstalledDate: '',
            subsequentInstalledDate: '',
            installationDepth: 0,
            installationAtSvlntrsv: '',
            trsvType: '',
            status: '',
            remark: '',
        };
        Object.assign(this, initialValues);
    }
}